export const UserType = {
    Reseller: 'Reseller',
    Merchant: 'Merchant',
    Admin: 'Admin',
    Owner: 'Owner',
    SuperAdmin: 'SuperAdmin'
};
